// 版本中文翻译
export default {
  tb: {
    name: "暗流涌动",
    description:
      "乌云笼罩瑞文斯伍德布拉夫，将这个沉睡的小镇及其迷信的居民吞没在不祥的阴影中。新洗的衣服在小屋之间挂着的绳子上诡异地舞动。烟囱向空中喷出缕缕烟雾。异国情调的香气透过窗户的缝隙和门下飘散，因为隐藏的大锅正在沸腾。异常温暖的秋风环绕着爬满藤蔓的墙壁，对那些勇敢走在鹅卵石街道上的人低语不祥的预兆。\n\n焦虑的母亲们把孩子们从游戏中叫回家，因为雷声开始在地平线上轰鸣。然而，如果你仔细聆听，还能听到从邻近森林传来的更奇怪的声音。在高耸的修道院的注视下，模糊的人影从一个门口跳到另一个门口。那些能读懂迹象的人知道...暗流涌动。",
    level: "新手",
  },
  bmr: {
    name: "月黯风高",
    description:
      "太阳被锯齿状的地平线吞没，又一个冬日向夜晚投降。橙色和红色的斑点腐烂成更深的棕色，森林在即将到来的降雪的寂静期待中变化。\n\n贪婪的狼群从城镇边界外的岩石裂缝的深处嚎叫，将鸟儿从它们舒适的巢穴中惊散。旅行者匆匆赶往客栈，寻求庇护免受聚集的寒气。他们用热茶、甜美的音乐旋律和丰盛的麦芽酒温暖自己，却不知道奇怪而邪恶的眼睛正从这座曾经伟大的城市的废墟中跟踪他们。\n\n今晚，连牲畜都知道有一个...月黯风高。",
    level: "进阶",
  },
  snv: {
    name: "异教紫罗兰",
    description:
      "生机勃勃的春天让位于温暖而诱人的夏天。各种各样的花朵尽可能远地盛开，在公共花园中得到精心培育，窗台上的花盆俯瞰着奢华的长廊。鸟儿歌唱，艺术家作画，哲学家在繁忙的酒馆里思考人生最大的奥秘，而马戏团在城镇边缘搭起了它迷人而破旧的帐篷。\n\n当镇民沉浸在欢乐和恶作剧中，沉迷于精彩的娱乐和更精致的葡萄酒时，黑暗而秘密的力量正在集结。女巫和邪教潜伏在社区边缘的宏伟废墟中，在地下洞穴中举行秘密会议，恶意地策划瑞文斯伍德布拉夫及其狂欢者的覆灭。\n\n时机已经成熟...异教紫罗兰。",
    level: "进阶",
  },
  luf: {
    name: "自由放任",
    description: "",
    level: "老手",
  },
};
